// extracted by mini-css-extract-plugin
export default {"dropdown":"ImportFile_dropdown__3qqHs","pasteDataHere":"ImportFile_pasteDataHere__KLzPd","uploadArea":"ImportFile_uploadArea__6EWXx"};